export default __webpack_public_path__ + "static/media/image.ceyleon-solutions.51b43678.png";